import { isObject } from "../object";

export const update = <T>(
  array: Array<T>,
  indexOrPredicate: number | ((item: T) => boolean),
  newProperties: Partial<T>,
  replace = false
): Array<T> => {
  let index;

  if (typeof indexOrPredicate === "function") {
    index = array.findIndex(indexOrPredicate);
  } else {
    index = indexOrPredicate;
  }

  return [
    ...array.slice(0, index),
    isObject(newProperties) && !replace ? ({ ...array[index], ...newProperties } as T) : (newProperties as T),
    ...array.slice(index + 1),
  ];
};

export const remove = <T>(array: Array<T>, indexOrPredicate: number | ((item: T) => boolean)): Array<T> => {
  let index;

  if (typeof indexOrPredicate === "function") {
    index = array.findIndex(indexOrPredicate);
  } else {
    index = indexOrPredicate;
  }

  return [...array.slice(0, index), ...array.slice(index + 1)];
};

export const add = <T>(array: Array<T>, newItem: T): Array<T> => {
  return [...array, newItem];
};

export const insert = <T>(array: Array<T>, indexOrPredicate: number | ((item: T) => boolean), newItem: T): Array<T> => {
  let index;

  if (typeof indexOrPredicate === "function") {
    index = array.findIndex(indexOrPredicate);
  } else {
    index = indexOrPredicate;
  }

  return [...array.slice(0, index), newItem, ...array.slice(index)];
};

export const reorder = <T>(array: Array<T>, from: number, to: number): Array<T> => {
  return insert(remove(array, from), to, array[from]);
};
